module.exports = __webpack_public_path__ + "static/media/asset3.4bb7b333.svg";